/**
 * Notificación de Regalo en el Carrito (WIM)
 * Obtiene los nombres de los productos de regalo para las notificaciones
 * y actualiza el texto de marcador de posición dinámicamente.
 */
(function () {
  const CACHE = {};

  async function fetchVariantInfo(variantId) {
    if (CACHE[variantId]) return CACHE[variantId];
    try {
      const res = await fetch(`/variants/${variantId}.js`);
      if (!res.ok) return null;
      const data = await res.json();
      // API de variantes de Shopify: "name" = "Título del Producto - Título de Variante"
      // Quita la parte de la variante para obtener solo el título del producto
      let title = data.name || data.title || null;
      if (title && data.public_title && title.endsWith(` - ${data.public_title}`)) {
        title = title.slice(0, -(` - ${data.public_title}`).length).trim();
      }
      // featured_image es nulo para productos con una sola variante.
      // La imagen es manejada por Liquid a través del productImage guardado en el metafield.
      const info = { title };
      CACHE[variantId] = info;
      return info;
    } catch (e) {
      return null;
    }
  }

  async function fillGiftNotifications(root) {
    const notifications = (root || document).querySelectorAll('.cart__gift-preview');
    for (const el of notifications) {
      if (el.dataset.loaded === 'true') continue;
      const variantId = el.dataset.rewardVariantId;
      if (!variantId) continue;

      const info = await fetchVariantInfo(variantId);
      if (!info) continue;

      // Llena el título si Liquid dejó el marcador de posición (falta productTitle en el metafield)
      const nameEl = el.querySelector('.cart__gift-preview__name');
      if (nameEl && info.title) {
        nameEl.textContent = info.title;
      }

      el.dataset.loaded = 'true';
    }
  }

  document.addEventListener('DOMContentLoaded', () => fillGiftNotifications());

  // Escucha los eventos nativos de FoxTheme para actualizar notificaciones
  document.addEventListener('theme:cart:refresh', () => fillGiftNotifications());
  document.addEventListener('theme:cart:updated', () => fillGiftNotifications());

  // Observa cambios en el DOM para inyectar información de regalos dinámicamente
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType === 1) {
          if (node.classList && node.classList.contains('cart__gift-preview')) {
            fillGiftNotifications(node.parentElement);
          } else if (node.querySelector && node.querySelector('.cart__gift-preview')) {
            fillGiftNotifications(node);
          }
        }
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
